export default __webpack_public_path__ + "static/media/lambo.f2f4e8a0.png";